import Encoding from "encoding-japanese";

import SearchGroupModalView from "../events/guests/searchGroupModal.html";
import AssignTagsPersonModalView from "../tags/AssignTagsModal.html";

angular.module("persons")

    .controller("PersonsListCtrl", ['datasetsService', 'notificationService', 'treeService', '$sce', '$uibModal', 'LoginService', '$stateParams', '$filter', '$rootScope', '$scope', '$http', '$interval', '$q', 'Upload', 'Restangular', 'gridService', 'modalService', '$translate', '$window', '$state', 'generateDocumentService','$timeout', 'logService',
        function (datasetsService, notificationService, treeService, $sce, $uibModal, LoginService, $stateParams, $filter, $rootScope, $scope, $http, $interval, $q, Upload, Restangular, gridService, modalService, $translate, $window, $state, generateDocumentService, $timeout, logService) {

            // Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("PERSONS_WRITE");
            $scope.allowDelete = LoginService.permissionExist("PERSONS_DELETE");
            $scope.allowDiscard = LoginService.permissionExist("PERSONS_DISCARD");
            $scope.allowImport = LoginService.permissionExist("PERSONS_IMPORT");

            let importCSVConfigured = false;

            $scope.duplicate_string = $filter('translate')('persons.duplicate_string');
            $scope.private_string = $filter('translate')('persons.is_private');

            $scope.selectOptionsRegister = [
                { id: 'notRegistered', value: $filter('translate')('persons.selectNotRegistered') },
                { id: 'registered', value: $filter('translate')('persons.selectRegistered') },
                { id: 'pendingRegistered', value: $filter('translate')('persons.selectPendingRegistered') },
                { id: 'registerExpired', value: $filter('translate')('persons.selectRegisterExpired') }
            ];

            $scope.update_data = {};

            $scope.personFilter = {
                name: "",
                surname: "",
                lastname: "",
                position: "",
                state: "",
                group_id: null,
                listPositionsIds: [],
                is_active: true,
                is_death: false,
                positions_inactives: false,
                event: "",
                person_registered: "",
                get_duplicates: false
            };

            Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {
                $scope.app_enabled = results.public_guest_app_enabled;
                //Mostramos o no la coluna del grid en función de la variable de empresa
                $scope.gridOptions.columnDefs[11].visible = $scope.app_enabled;
            }, function (response) {
                $scope.errorMessage = response.message;
            });

            // reseteamos los filtros del buscador

            if (!angular.isDefined($stateParams.reset)) $stateParams.reset = true;

            if ($stateParams.reset == "true") {
                localStorage.removeItem("persons_filters");
            } else {
                var savedFilters = localStorage.getItem("persons_filters");
                if (savedFilters != null) {
                    $scope.personFilter = JSON.parse(savedFilters);
                    $scope.personFilter.group_id = null;
                }
            }

            $scope.filteredGroupName = null;

            if ($stateParams.group_id != null && $stateParams.group_id !== "") {

                let groupId = parseInt($stateParams.group_id, 10);
                if (!isNaN(groupId)) {
                    $scope.personFilter.group_id = groupId;
                    $scope.personFilter.listPositionsIds = [];
                }
            }

            if ($scope.personFilter.group_id != null && $scope.filteredGroupName == null) {
                Restangular.one('Groups', $scope.personFilter.group_id).get().then(function (result) {
                    if (result.FK_groups_tl_groups != null && result.FK_groups_tl_groups.length > 0) {
                        $scope.filteredGroupName = result.FK_groups_tl_groups[0].name;
                    } else {
                        $scope.filteredGroupName = result.name || null;
                    }
                });
            }

            if ($stateParams.person_type == 'authority') {
                $rootScope.title = $filter('translate')('persons.title');
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('persons.subtitle') }
                ];
            }
            else if ($stateParams.person_type == 'anonymous') {
                $rootScope.title = $filter('translate')('persons.title_anonymous');
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('persons.title_anonymous') }
                ];
            }
            else if ($stateParams.person_type == 'imported') {
                $rootScope.title = $filter('translate')('persons.title_imported');
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('persons.title_imported') }
                ];
            }
            else if ($stateParams.person_type == 'enrolled') {
                $rootScope.title = $filter('translate')('inscriptions_forms.inscripted');
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('inscriptions_forms.inscripted') }
                ];
            } else {
                $rootScope.title = $filter('translate')('persons.title_all');
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('persons.title_all') }
                ];
            }

            $scope.person_type = $stateParams.person_type;

            var optionsPIGa = { entity_type: "persons" };

            Restangular.all('InformationsGroups').getList(optionsPIGa).then(function (personsInformationGroups) {

                $scope.personsInformationGroups = personsInformationGroups;

                angular.forEach($scope.personsInformationGroups, function (pig) {
                    if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
                });

                $scope.checkboxSimpleOptions = [
                    { option: null, label: $filter('translate')('informations.all'), checked: true },
                    { option: true, label: $filter('translate')('events.staff.yes'), checked: false },
                    { option: false, label: $filter('translate')('events.staff.no'), checked: false }
                ];

            });

            $scope.composeUiPopover = function (group_id) {

                var options: any = {}
                options.id = group_id;

                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'Groups/GetGroupsAndParent',
                    params: options
                }).then(function (results, status, headers, config) {

                    var data = treeService.groups(results.data, null, false);
                    let html = "";
                    
                    angular.forEach(data, function (item) {
                        html += item.customName + "<br>";
                    });

                    $scope.valuePopover = $sce.trustAsHtml(html);

                });

            };

            var trusted = {};

            $scope.getPopoverContent = function (html) {
                return trusted[html] || (trusted[html] = $sce.trustAsHtml(html));
            };

            // Marcamos 'duplicados' de forma similar a cómo lo hacemos en people_import
            $scope.rowFormatter = function (row) {
                return row.entity.imported_duplicate_ext_id != null;
            };

            $scope.gridOptions = {
                exporterMenuCsv: false,
                enableFiltering: false,
                enableGridMenu: true,
                paginationPageSizes: [150, 300, 450],
                pdfTitle: $rootScope.title,
                paginationPageSize: 50,
                rowHeight: 50, // Ampliamos las filas para que quepan los tags debajo del nombre
                exporterSuppressColumns: ["image_id","position_for_anonymous"],//la eliminamos porque no funciona con la url, probar con base64 si se quiere.
                exporterOlderExcelCompatibility: true,
                // rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, exporterSuppressExport: true, width: 80 },
                    { name: 'id_ext', visible: false, exporterSuppressExport: true, width: 80 },
                    {
                        name: 'is_active', displayName: " ", visible: false, exporterSuppressExport: true, width: 30, enableHiding: false, 
                        //cellTemplate: '<div class="ui-grid-cell-contents">row.entity.is_active<span class="label label-danger" ng-show="!row.entity.is_active">Activo<span><span class="label label-primary" ng-show="row.entity.is_active">a<span></div>'
                        cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: center;\">" +
                            "<span ng-if=\"!row.entity.is_active\" class=\"label label-danger\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                            "<span ng-if=\"row.entity.is_active\" class=\"label label-primary\" style=\"display:inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                            "</div>"
                    },
                    {
                        field: 'image_id',
                        enableSorting: false,
                        visible: false, //$stateParams.person_type != 'anonymous' && $stateParams.person_type != 'enrolled',
                        width: 50,
                        enableFiltering: false,
                        /*
                           customFormatFn: function (value) {
                               no funciona con una imagen de url.
                                if (value != null) {
                                    var img = {
                                        image: value,
                                        width: 30
                                    };
                                    return img;
                                } else {
                                    return "";
                                }
                            },
                        */
                        displayName: $filter('translate')('persons_reports.photo'),
                        cellTemplate: "<div style='height: 28px; overflow: hidden;'><img width=\"28px\" ng-show=\"grid.getCellValue(row, col)\" ng-src=\"/api/Image/GetImageBmp?id={{row.entity.image_id}}&maxW=28&maxH2=28\" style=\"margin-left:5px;margin-top:0px\" lazy-src></div>"
                    },
                    {
                        name: 'event_name', displayName: $filter('translate')('persons.event'), enableFiltering: true, enableHiding: false, visible: $stateParams.person_type === 'anonymous' || $stateParams.person_type === 'enrolled',
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope"><span ng-if="row.entity.total_events_guests == 1">{{ row.entity.event_name }}</span><span ng-if="row.entity.total_events_guests > 1"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="grid.appScope.getPopoverContent(row.entity.all_events_names)" popover-append-to-body="true">{{row.entity.event_name}}</a></span></div>',
                    },
                    {
                        customFormatFn: function (value) {
                            if (value != null) {
                                if (value.contains("<br>")) value = value.replaceAll("<br>", "\n");
                            }
                            return value;
                        },
                        name: 'position_for_anonymous', displayName: $filter('translate')('persons.active_positions'),
                        enableFiltering: false, enableSorting: false, width: '*', enableHiding: true, visible: $stateParams.person_type === 'anonymous',
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope"><span ng-if="row.entity.FK_persons_positions_persons.length == 0">-- ' + $filter('translate')('persons.no_position') + ' -- </span><span ng-if="row.entity.FK_persons_positions_persons.length > 1"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="grid.appScope.getPopoverContent(row.entity.position_and_group_name)" popover-append-to-body="true">-- ' + $filter('translate')('persons.many_positions') + ' -- </a></span><span ng-if="row.entity.FK_persons_positions_persons.length == 1"><a class="aColorGrey margin-right-5" ng-click="$event.stopPropagation();grid.appScope.composeUiPopover(row.entity.groupId)" popover-placement="right" popover-trigger="click outsideClick" uib-popover-html="grid.appScope.valuePopover" popover-append-to-body="true"><i class="fa fa-sitemap"></i></a><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="row.entity.position_and_group_name" popover-append-to-body="true"><span ng-if="row.entity.FK_persons_positions_persons[0].to_date != null">({{ row.entity.FK_persons_positions_persons[0].to_date | toLocalDate | date: \'dd/MM/yyyy\' }}) </span>{{row.entity.position_and_group_name}}</a></span></div>',
                    },
                    {
                        name: 'name', displayName: $filter('translate')('persons.name'), enableFiltering: true, enableHiding: false, minWidth: 80, maxWidth: 150,
                        cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<div> <span ng-if= "row.entity.imported_duplicate_ext_id != null" class= "fa fa-triangle-exclamation fa-lg" style="color: #bb1010;" > </span> {{ row.entity.name }} </div >' + 
                            '<div ng-if="row.entity.tags.length == 1" ng-bind-html="row.entity.tagsHtml"></div>' +
                            '<div ng-if="row.entity.tags.length > 1" popover-placement="auto" popover-trigger="mouseenter" uib-popover-html="row.entity.tagsHtml" popover-append-to-body="true"> <span class="badge"> <b> --' + $filter('translate')('persons.many_tags') + '-- </b> </span> </div>' +
                            '</div>'
                    },
                    {   name: 'surname', displayName: $filter('translate')('persons.surname'), enableFiltering: true, enableHiding: true, minWidth: 80, maxWidth: 150 },
                    {   name: 'lastname', displayName: $filter('translate')('persons.lastname'), enableFiltering: true, enableHiding: true, minWidth: 60, maxWidth: 150 },
                    {
                        name: 'position_order', width: 100, displayName: $filter('translate')('persons.position_order'), enableFiltering: true, enableHiding: true
                    },
                    {
                        customFormatFn: function (value) {
                            if (value.contains("<br>")) value = value.replaceAll("<br>", "\n");
                            return value;
                        },
                        name: 'position_and_group_name', displayName: $filter('translate')('persons.active_positions'),
                        enableFiltering: false, enableSorting: false, width: '*', enableHiding: true, visible: $stateParams.person_type !== 'anonymous' && $stateParams.person_type !== 'enrolled',
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope"><span ng-if="row.entity.FK_persons_positions_persons.length == 0">-- ' + $filter('translate')('persons.no_position') + ' -- </span><span ng-if="row.entity.FK_persons_positions_persons.length > 1"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="grid.appScope.getPopoverContent(row.entity.position_and_group_name)" popover-append-to-body="true">-- ' + $filter('translate')('persons.many_positions') + ' -- </a></span><span ng-if="row.entity.FK_persons_positions_persons.length == 1"><a class="aColorGrey margin-right-5" ng-click="$event.stopPropagation();grid.appScope.composeUiPopover(row.entity.groupId)" popover-placement="right" popover-trigger="click outsideClick" uib-popover-html="grid.appScope.valuePopover" popover-append-to-body="true"><i class="fa fa-sitemap"></i></a><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="row.entity.position_and_group_name" popover-append-to-body="true"><span ng-if="row.entity.FK_persons_positions_persons[0].to_date != null">({{ row.entity.FK_persons_positions_persons[0].to_date | toLocalDate | date: \'dd/MM/yyyy\' }}) </span>{{row.entity.position_and_group_name}}</a></span></div>',
                    },
                    {
                        name: 'user', width: 100, displayName: $filter('translate')('general.user'), enableFiltering: true, enableHiding: false, visible: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope"><span ng-if="row.entity.username !=null">{{ row.entity.username }}</span><span ng-if="row.entity.register_pending" style="color:#1ab394"><b>' + $filter('translate')('persons.pte_register') + '</b></span></div>',
                    },
                    {
                        name: '  ', width: 100, enableFiltering: true, enableHiding: false, visible: true,
                        cellTemplate: `<div class="ui-grid-cell-contents ng-binding ng-scope"><span ng-if="row.entity.duplicate_of" style="color:#1ab394" title="{{grid.appScope.duplicate_string}}"><i class="fas fa-user-tag"></i></span></div>`,
                    },
                    {
                        name: '  ', width: 100, enableFiltering: true, enableHiding: false, visible: true,
                        cellTemplate: `<div class="ui-grid-cell-contents ng-binding ng-scope"><span ng-if="row.entity.is_private" title="{{grid.appScope.private_string}}"><i class="fas fa-eye-slash"></i></span></div>`,
                    },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            //{ title: $filter('translate')('persons.convert_to_authority'), action: 'ng-if="row.entity.person_type==\'other\' || row.entity.person_type==\'anonymous\' || row.entity.person_type==\'imported\'" ng-click="grid.appScope.convertToType(row.entity, \'authority\')"', cssIconClass: "fa fa-exchange" },
                            //{ title: $filter('translate')('persons.convert_to_other'), action: 'ng-if="row.entity.person_type==\'anonymous\' || row.entity.person_type==\'imported\'" ng-click="grid.appScope.convertToType(row.entity, \'other\')"', cssIconClass: "fa fa-exchange" },
                            //{ title: $filter('translate')('persons.edit'), action: 'ng-if="row.entity.is_active || row.entity.person_type==\'anonymous\' || row.entity.person_type==\'imported\'" ui-sref="persons.edit({person_type: row.entity.person_type, id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('events.user_view'), action: 'ng-click="grid.appScope.goToImportDuplicate(row.entity.imported_duplicate_ext_id)"; ng-if="row.entity.imported_duplicate_ext_id"', cssIconClass: "fa fa-users" },
                            { title: $filter('translate')('persons.edit'), action: 'ng-click="grid.appScope.goToEdit(row.entity)"', cssIconClass: "fa fa-edit" },
                            //{ title: $filter('translate')('persons.edit'), action: 'ng-if="!row.entity.is_active" ui-sref="persons.edit({person_type: \'inactive\', id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('persons.button_delete'), action: 'ng-click="grid.appScope.DeleteDialog(row.entity.id,row.entity.name, row.entity.surname);" ng-if="grid.appScope.allowWrite && (grid.appScope.allowDelete || (grid.appScope.allowDiscard && (grid.appScope.person_type==\'anonymous\' || grid.appScope.person_type==\'imported\' || grid.appScope.person_type==\'enrolled\')))" ', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                rowTemplate: '<div ng-class="{ \'ui-grid-row-info\': grid.appScope.rowFormatter( row ) }">' +
                    '  <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }"  ui-grid-cell ng-dblclick="grid.appScope.goToEdit(row.entity)" style="cursor:pointer;"></div>' +
                    '</div>',
                getData: function (options) {

                    options.person_type = $scope.person_type;
                    options.is_active = $scope.personFilter.is_active ? true : false;
                    options.is_death = $scope.personFilter.is_death ? true : false;
                    options.positions_inactives = $scope.personFilter.positions_inactives;

                    if ($scope.personFilter.name != "") options.name = $scope.personFilter.name;
                    if ($scope.personFilter.surname != "") options.surname = $scope.personFilter.surname;
                    if ($scope.personFilter.lastname != "") options.lastname = $scope.personFilter.lastname;
                    if ($scope.personFilter.position != "") options.position_name = $scope.personFilter.position;
                    if ($scope.personFilter.institution != "") options.institution = $scope.personFilter.institution;
                    if ($scope.personFilter.event_name != "") options.event_name = $scope.personFilter.event_name;
                    if ($scope.personFilter.state != "") options.state = $scope.personFilter.state;
                    if ($scope.personFilter.phone != "") options.phone = $scope.personFilter.phone;
                    if ($scope.personFilter.mail != "") options.mail = $scope.personFilter.mail;
                    if ($scope.personFilter.person_registered != "") options.person_registered = $scope.personFilter.person_registered;
                    if ($scope.personFilter.group_id != null) options.group_id = $scope.personFilter.group_id;
                    if ($scope.personFilter.listPositionsIds.length > 0) options.listPositionsIds = $scope.personFilter.listPositionsIds;
                    if ($scope.personFilter.get_duplicates == true) options.get_duplicates = true;
                    if ($scope.tags != null) options.tags = $scope.tags;

                    var pigs = "";
                    for (var key in $scope.personFilter.pigs) {

                        if (typeof $scope.personFilter.pigs[key] != "undefined" && $scope.personFilter.pigs[key] != "" && $scope.personFilter.pigs[key] != null) {
                            if (typeof ($scope.personFilter.pigs[key]) == "object") {
                                //estamos en el selector simple.
                                var infoFilter = $scope.personsInformationGroups.filter(function (el) { return el.id == key; });
                                if (infoFilter.length == 1) {
                                    if (infoFilter[0].type == "datetime") {
                                        if ($scope.personFilter.pigs[key] != null) pigs += (pigs != "" ? "#" : "") + key + "=>" + new Date($scope.personFilter.pigs[key]).toISOString();
                                    } else if (infoFilter[0].type == "checkboxSimple") {
                                        if ($scope.personFilter.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.personFilter.pigs[key].checked;
                                    } else {
                                        pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.personFilter.pigs[key];
                                    }
                                }
                            } else {
                                pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.personFilter.pigs[key];
                            }
                        }
                    }

                    options.pigs = pigs;

                    //guardamos filtros
                    var filtersToPersist = angular.copy($scope.personFilter);
                    filtersToPersist.group_id = null;
                    localStorage.setItem("persons_filters", JSON.stringify(filtersToPersist));

                    //guardamos opciones
                    localStorage.setItem("persons_options", JSON.stringify(options));
                    var deferred = $q.defer();

                    Restangular.all('Persons/GetAllPersonsFiltered').post(options).then(function (results) {
                        var data = results.rows;
                        $scope.personsIds = results.allRowsResultIds;

                        //Obtenemos sus imágenes
                        let visibleIds = results.rows.map(function (row) { return row.id; });

                        if (visibleIds.length > 0 && options._pageSize != null) {

                        // para que no casque si quieren imprimir todo...

                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'Persons/ImagesSmall',
                                params: { ids: visibleIds }
                            }).then(function (resultsImage, status, headers, config) {
                                angular.forEach(data, function (person) {
                                    for (var i = 0; i < resultsImage.data.length; i++) {
                                        if (person.id == resultsImage.data[i].person_id) {
                                            person.image_small = resultsImage.data[i].image_small;
                                            break;
                                        }
                                    }
                                });
                            });

                        } 

                        // Metemos los tags
                        data.forEach(function (row) {

                            if (row.tags.length > 0) {

                                let tagsHtml = row.tags.map(function (tag) {
                                    return `<span class="badge" style="color:white; background-color:${tag.color}"> <i class="fas fa-${tag.icon} m-r-sm"></i> ${tag.title} </span>`;
                                }).join('<br>');

                                row.tagsHtml = $sce.trustAsHtml(tagsHtml);

                            }

                        });

                        data.totalRows = results.totalRows;
                        $scope.totalRows = results.totalRows;
                        $scope.persons = data;

                        deferred.resolve(data);

                });

                    return deferred.promise;
                }
            };

            $scope.goToEdit = function (rowEntity) {

                var idx = 0;

                $scope.persons.forEach(function (row, index) {
                    if (row.id == rowEntity.id) idx = index;
                });

                var savedOptions = JSON.parse(localStorage.getItem("persons_options") || "{}");
                var offset = (savedOptions._page - 1) * savedOptions._pageSize;
                savedOptions.row_index = offset + idx;
                savedOptions.totalRows = $scope.totalRows;

                localStorage.setItem("persons_options", JSON.stringify(savedOptions));
                $state.go("persons.edit", { person_type: rowEntity.person_type, id: rowEntity.id, personsIds: $scope.personsIds });

            };

            $scope.goToImportDuplicate = function (id) {
                var url = $state.href("persons.edit", { person_type: 'authority', id: id, personsIds: [] });
                $window.open(url, '_blank');
            }

            let filter = false;
            $scope.searchPersons = function () {
                if (angular.isDefined($scope.gridOptions.loadData)) {
                    filter = true;
                    $scope.gridOptions.loadData(false);
                }
            };

            $scope.deleteSelected = function () {
                let rows = $scope.gridOptions.gridApi.selection.getSelectedRows();
                let ids: any[] = [];
                angular.forEach(rows, function (row) {
                    ids.push(row.id);
                });
                if (ids.length > 0) {
                    modalService.confirm({
                        title: $filter('translate')('persons.button_delete'),
                        message: $filter('translate')('persons.delete_all_message'),
                        onAccept: function () {

                            let options = {
                                ids: ids,
                                type: $stateParams.person_type
                            };
                            Restangular.all('Persons/DeleteAll').remove(options).then(function (result) {
                                toastr.success($filter('translate')('persons.delete_success'));
                                $scope.gridOptions.loadData(false);
                            });

                        }
                    });
                }
            };

            $scope.DeleteDialog = function (id, name, surname) {
                $scope.id = id;
                $scope.name = name + " " + surname;
                modalService.confirm({
                    title: $filter('translate')('persons.button_delete'),
                    message: $filter('translate')('persons.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Persons', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('persons.delete_success'));
                            $scope.gridOptions.loadData(false);
                        }, function (response) {
                            logService.error("Error with status code", response.status);
                            toastr.error($filter("translate")("general.delete_error_message"))
                        });
                    }
                });
            };

            $scope.export = function () {

                var options = {

                    filters: {

                        PERSON_TYPE: $scope.person_type,
                        NAME: $scope.personFilter.name,
                        SURNAME: $scope.personFilter.surname,
                        LASTNAME: $scope.personFilter.lastname,
                        POSITION: $scope.personFilter.position,
                        STATE: $scope.personFilter.state,
                        LIST_POSITIONS_IDS: $scope.personFilter.listPositionsIds,
                        IS_ACTIVE: $scope.personFilter.is_active ? true : false,
                        POSITIONS_INACTIVE: $scope.personFilter.positions_inactives,
                        IS_DEATH: $scope.personFilter.is_death ? 1 : 0

                    }

                };

                var n = 0;

                for (var key in $scope.personFilter.pigs) {
                    n++;
                    if (!angular.isUndefined($scope.personFilter.pigs[key].checked)) {
                        options.filters["PIG" + n] = "#" + key + "=" + $scope.personFilter.pigs[key].checked + "#";
                    } else {
                        options.filters["PIG" + n] = "#" + key + "=" + $scope.personFilter.pigs[key] + "#";
                    }
                }

                datasetsService.exportByType("persons", options);

            };

            let initImportCSV = function (type) {
                $("#frmCSV").change(function () {
                    const fileInput = document.querySelector('#frmCSV') as HTMLInputElement;
                    let file = fileInput?.files?.[0];
                    if (file) {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            const codes = new Uint8Array(e.target?.result as ArrayBuffer);
                            const detectedEncoding = Encoding.detect(codes);
                            try {
                                let unicodeString = Encoding.convert(codes, {
                                    to: 'unicode',
                                    from: detectedEncoding,
                                    type: 'string'
                                });

                                let request = {
                                    file: btoa(unicodeString),
                                    person_type: type,
                                    mime: file.type
                                }
                                Restangular.all('Persons/ImportCSV').post(request).then(function (data) {
                                    $state.go('persons.import', { people: data, person_type: $scope.person_type });
                                });
                            } catch (e) {
                                // Uncaught RangeError: Maximum call stack size exceeded
                            }
                        };
                        reader.readAsDataURL(file);
                    }
                });

            };

            $scope.importCSV = function (type) {
                if (!importCSVConfigured) {
                    importCSVConfigured = true;
                    initImportCSV(type);
                }
                $("#frmCSV").trigger("click");
            };

            $scope.convertToType = function (type) {
                //Voy a ignoarar esta opción en el masivo. Ahora sólo se mandará los que están siendo visibles en la vista, no más, porque
                //sino hay problemas con los filtros, si filtran, y seleccionan el único resultado, está mandando el addAll y entonces se pasan TODOS.
                //var addAll = $scope.gridOptions.gridApi.selection.getSelectAllState();
                var addAll = false;

                var rows = $scope.gridOptions.gridApi.selection.getSelectedRows();
                var ids: any[] = [];
                var rowsToMerge: any[] = []; // Las personas a las que vamos a fusionar con una autoridad
                angular.forEach(rows, function (row) {
                    if (row.imported_duplicate_ext_id != null) {
                        rowsToMerge.push(row); // Añadimos 0 de placeholder para que no nos lo detecte vacío
                    } else {
                        ids.push(row.id);
                    }
                });
                if (ids.length > 0 || rowsToMerge.length > 0) {
                    $scope.update_data.all_persons = false;//addAll;
                    $scope.update_data.add_persons_duplicates = false;
                    $scope.update_data.id_list = ids;
                    $scope.update_data.old_type = $stateParams.person_type;
                    $scope.update_data.new_type = type;
                    modalService.confirm({
                        title: $filter('translate')('persons.convert_to_' + type),
                        message: $filter('translate')('persons.convert_to_' + type + '_message_massive'),
                        onAccept: function () {
                            if ($stateParams.person_type == "anonymous" || $stateParams.person_type == "imported" || $stateParams.person_type == "enrolled") {

                                // Importamos aquellos con id_ext coincidente
                                rowsToMerge.forEach(function (row) {
                                    $scope.mergeWithAuthority(row);
                                });

                                //preparamos opciones
                                var options = {
                                    all: addAll,
                                    ids: ids,
                                    type: $stateParams.person_type /*,
                                    person_type: $scope.person_type,
                                    name: $scope.personFilter.name,
                                    surname: $scope.personFilter.surname,
                                    lastname: $scope.personFilter.lastname,
                                    position_name: $scope.personFilter.position,
                                    listPositionsIds: $scope.personFilter.listPositionsIds*/

                                };
                                Restangular.all('Persons').customGET("CheckIfExistsMassive", options).then(function (result) {
                                    if (result.ids != "" && result.ids !== null) {
                                        var arrayIds = result.ids.split(",");
                                        $scope.update_data.id_list = arrayIds;

                                        /*angular.forEach(arrayIds, function (item) {
                                            var indice = $scope.update_data.id_list.indexOf(parseInt(item));
                                            if (indice == 0) {
                                                $scope.update_data.id_list.splice(indice, 1);
                                            }
                                        });*/

                                        modalService.confirm({
                                            title: $filter('translate')('persons.person_already_exist_massive'),
                                            message: $filter('translate')('persons.person_already_exist_message_massive') + "<br><br>" + result.message,
                                            onAccept: function () {
                                                $scope.update_data.add_persons_duplicates = true;
                                                $scope.update_data.id_list = ids;
                                                Restangular.all('Persons/UpdateTypeMassive').post($scope.update_data).then(function (data) {
                                                    toastr.success($filter('translate')('persons.update_massive_success'));
                                                    $scope.gridOptions.loadData(false);
                                                });
                                            },
                                            onCancel: function () {
                                                $scope.update_data.add_persons_duplicates = false;
                                                $scope.update_data.id_list = ids;
                                                Restangular.all('Persons/UpdateTypeMassive').post($scope.update_data).then(function (data) {
                                                    toastr.success($filter('translate')('persons.update_massive_success'));
                                                    $scope.gridOptions.loadData(false);
                                                });
                                            }
                                        });
                                    } else {
                                        Restangular.all('Persons/UpdateTypeMassive').post($scope.update_data).then(function (data) {
                                            toastr.success($filter('translate')('persons.update_massive_success'));
                                            $scope.gridOptions.loadData(false);
                                        });
                                    }
                                });
                            } else {
                                Restangular.all('Persons/UpdateTypeMassive').post($scope.update_data).then(function (result) {
                                    toastr.success($filter('translate')('persons.update_massive_success'));
                                    $scope.gridOptions.loadData(false);
                                });
                            }
                        }
                    });
                } else {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('persons.select_persons'),
                        onAccept: function () { }
                    });
                }
            };

            $scope.searchGroup = function () {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: SearchGroupModalView,
                    size: "lg",
                    controller: "SearchGroupModalCtrl",
                    resolve: {
                        preselect: function () {
                            return false;  //para preseleccionar los grupos ya buscados
                        },
                        event_id: function () {
                            return 0;
                        },
                        is_filter: function () {
                            return false;
                        },
                        listGroupsIds: function () {
                            return [];
                        },
                        listPositionsIds: function () {
                            return [];
                        }
                    }
                });

                //Response del modal
                $modalInstance.result.then(function (groups) {
                    if (groups.listPositions.length > 0) {
                        $scope.personFilter.group_id = null;
                        $scope.personFilter.listPositionsIds = groups.listPositions;
                        $scope.filteredGroupName = null;
                        $scope.searchPersons();
                    }
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });

            };

            $scope.clearGroupFilter = function () {
                $scope.personFilter = {
                    name: "",
                    surname: "",
                    lastname: "",
                    position: "",
                    state: "",
                    group_id: null,
                    is_active: true,
                    is_death: false,
                    event_name: "",
                    person_registered: "",
                    get_duplicates: false,
                    positions_inactives: false,
                    listPositionsIds: []
                };

                $scope.filteredGroupName = null;

                localStorage.removeItem("name");
                localStorage.removeItem("surname");
                localStorage.removeItem("lastname");
                localStorage.removeItem("position");
                localStorage.removeItem("positions_inactives");
                localStorage.removeItem("listPositionsIds");

                $scope.tags = [];

                $scope.searchPersons();
            };

            //

            $scope.mergeWithAuthority = function (rowEntity) { // TO BE CONTINUED
                Restangular.one("Persons/MergeWithAuthority").get({ importedId: rowEntity.id, authorityId: rowEntity.imported_duplicate_ext_id }).then(function (result) {
                    toastr.success($filter('translate')('persons.merge_with_authority_success'));
                    $scope.gridOptions.loadData(false);
                });
            };

            $scope.printDialog = function (code, type_document, type_result, id) {
                var rows = $scope.gridOptions.gridApi.selection.getSelectedRows();
                var persons_ids = _.chain(rows)
                    .map(function (row) { return row.id; })
                    .value();

                var params = {
                    entity_type: "persons",
                    entity_type_id: $stateParams.id,
                    persons_ids: persons_ids,
                    documents: { codes: [code] }
                };

                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: { document_id: item.document_id, persons_ids: persons_ids.toString(), order: item.url_params, outputType: 'pdf' }
                            }).then(function (result, status, headers, config) {
                                var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })
                    }
                });
            };

            $scope.sendPushNotifications = function () {
                var rows = $scope.gridOptions.gridApi.selection.getSelectedRows();
                var listIds = _.chain(rows)
                    .map(function (row) { return row.id; })
                    .value();
                if (listIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('persons.select_authority'),
                        onAccept: function () { }
                    });
                } else {
                    let params = {
                        listIds: listIds,
                        type: 'person'
                    };
                    notificationService.notificationPush({
                        params: params,
                        onAccept: function (data) {
                            toastr.success($filter('translate')('notifications.sending_mail_success'));
                        }
                    });
                }
            }

            $scope.sendMailing = function () {
                var rows = $scope.gridOptions.gridApi.selection.getSelectedRows();
                var listIds = _.chain(rows)
                    .map(function (row) { return row.id; })
                    .value();
                if (listIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('persons.select_authority'),
                        onAccept: function () { }
                    });
                } else {
                    var listEmailsIds = [];
                    Restangular.all("Persons").customGET("GetAllPersonsEmailsIds", { persons_ids: listIds }).then(function (res) {

                        listEmailsIds = res;

                        var params = {
                            entity_type: "persons",
                            entity_type_id: 0,
                            persons_ids: listIds,
                            mail_account_id: null,
                            mail_account_reply: null,
                            app_enabled: $scope.app_enabled,
                            documents: { for_event_guest: false }
                        };

                        notificationService.notificationMail({
                            params: params,
                            onAccept: function (data) {
                                toastr.success($filter('translate')('notifications.sending_mail_success'));
                            }
                        });

                    });
                }
            }

            $scope.assignTags = function () {
                var rows = $scope.gridOptions.gridApi.selection.getSelectedRows();
                var listIds = _.chain(rows)
                    .map(function (row) { return row.id; })
                    .value();
                if (listIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('persons.select_authority'),
                        onAccept: function () { }
                    });
                } else {

                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: AssignTagsPersonModalView,
                        size: "ld",
                        controller: "tagsModalCtrl",
                        scope: $scope,
                        resolve: {


                            is_search: function () {
                                return false
                            },

                            selected_tags_ids: function () {
                                return [];
                            },
                            entity_type: function () {
                                return "persons";
                            },
                            entity_id: function () {
                                return listIds;
                            }
                        }
                    });

                }
            }

            $scope.searchByTags = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AssignTagsPersonModalView,
                    size: "ld",
                    controller: "tagsModalCtrl",
                    scope: $scope,
                    resolve: {

                        is_search: function () {
                            return true
                        },

                        selected_tags_ids: function () {
                            return $scope.tags != null ? $scope.tags.map(m => m.id) : [];
                        },

                        entity_type: function () {
                            return "persons";
                        },
                        entity_id: function () {
                            return null;
                        }
                    }
                });

                $modalInstance.result.then(function (tagIdList) {
                    $scope.tags = [];
                    if (tagIdList != null && tagIdList.length > 0) {
                        Restangular.all("Tags").customGET("TagsByIdList", { id_list: tagIdList }).then(function (results) {
                            $scope.tags = results;
                            $scope.personFilter.tags = $scope.tags;
                            $scope.searchPersons();
                        });
                    } else {
                        $scope.searchPersons();
                    }
                }, function () {
                });

            }

        }]);
